export enum PLACEHOLDER {
  dashes = '--',
  enterJobName = 'Enter job name',
}
